/* unplugin-vue-components disabled */import { render } from "./FloatingSaveButton.vue?vue&type=template&id=9cef95d2&scoped=true"
import script from "./FloatingSaveButton.vue?vue&type=script&lang=js"
export * from "./FloatingSaveButton.vue?vue&type=script&lang=js"

import "./FloatingSaveButton.vue?vue&type=style&index=0&id=9cef95d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cef95d2"]])

export default __exports__